var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsDateString, IsEnum, IsInt, IsOptional, IsString, ValidateNested } from "class-validator";
import { Form, MimeType } from "../../model";
import { DocumentOrigin } from "../../model.types";
import { DocumentTagDTO } from "./document-tag.dto";
import { safeAssign } from "./safe-assign";
export class DocumentDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], DocumentDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentDTO.prototype, "type", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], DocumentDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentDTO.prototype, "comment", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DocumentDTO.prototype, "url", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], DocumentDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], DocumentDTO.prototype, "createdById", void 0);
__decorate([
    Expose(),
    IsEnum(DocumentOrigin),
    __metadata("design:type", String)
], DocumentDTO.prototype, "origin", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], DocumentDTO.prototype, "hideFromEmployee", void 0);
__decorate([
    Expose(),
    ValidateNested({ each: true }),
    Type(() => DocumentTagDTO),
    __metadata("design:type", Array)
], DocumentDTO.prototype, "tags", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    IsOptional(),
    Type(() => Form)
    //TODO: migrate Form to DTO
    ,
    __metadata("design:type", Object)
], DocumentDTO.prototype, "form", void 0);
//# sourceMappingURL=document.dto.js.map